/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForAnthropicPlatform extends models.ServiceAccountNativeDetailsBaseForAiPlatform {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForAnthropicPlatform");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForAnthropicPlatform.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForAnthropicPlatform>): ServiceAccountNativeDetailsForAnthropicPlatform {
        let obj = Object.assign(new ServiceAccountNativeDetailsForAnthropicPlatform(), model);
        ServiceAccountNativeDetailsForAnthropicPlatform.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForAnthropicPlatform>): ServiceAccountNativeDetailsForAnthropicPlatform {
        if (!model) return null;
        return ServiceAccountNativeDetailsForAnthropicPlatform.newInstance(<ServiceAccountNativeDetailsForAnthropicPlatform> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForAnthropicPlatform) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForAnthropicPlatform.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForAnthropicPlatform): boolean {
        if (models.ServiceAccountNativeDetailsBaseForAiPlatform.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForAnthropicPlatform.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Anthropic Organization Id. This is a required field.
     */
    organization_id: string;

    /**
     * Anthropic Organization Name. This is a required field.
     */
    organization_name: string;

}
